import * as XLSX from 'xlsx';
import { Empty } from '../../Screens/Kits/OilKits/ScreenAddOilKits/utils/types';

interface ExcelDataProps<T> {
  data: T[];
  removeSn?: boolean;
}

export const exportToExcelData = <T>({ data, removeSn }: ExcelDataProps<T>, name: string) => {
  const newData = data.map((item, index) => ({
    SN: { t: 's', v: index + 1, s: { alignment: { horizontal: 'left' } } },
    ...item, // You can set the value as per your requirement
  }));

  const ws = XLSX.utils.json_to_sheet(removeSn ? data : newData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'tais-sheet');

  XLSX.writeFile(wb, `${name}.xlsx`);
};

export const downloadExcelByUrl = (excelUrl: string) => {
  if (excelUrl) {
    // Create a hidden anchor element
    const a = document.createElement('a');
    a.style.display = 'none';
    document.body.appendChild(a);

    // Set the URL to the anchor's href attribute
    a.href = excelUrl;

    // Specify the filename for the downloaded file
    a.download = 'excel_data.xlsx';

    // Trigger a click event on the anchor to initiate the download
    a.click();

    // Remove the anchor from the DOM
    document.body.removeChild(a);
  }
};

export const generateReInspectionExcel = <T>(
  { data }: ExcelDataProps<T>,
  values: { to: string, from: string, subject: string, date: string, customerId: string },
) => {
  const ws = XLSX.utils.json_to_sheet(data, { origin: 11 } as Empty);
  ws.A1 = { t: 's', v: 'TO:' };
  ws.A3 = { t: 's', v: 'FROM:' };
  ws.A5 = { t: 's', v: 'SUBJECT:' };
  ws.A7 = { t: 's', v: 'DATE:' };
  ws.A9 = { t: 's', v: 'CUSTOMER#:' };
  ws.B1 = { t: 's', v: values?.to || '' };
  ws.B3 = { t: 's', v: values?.from || '' };
  ws.B5 = { t: 's', v: values?.subject || '' };
  ws.B7 = { t: 's', v: values?.date || '' };
  ws.B9 = { t: 's', v: values?.customerId || '' };
  ws['!cols'] = [
    { wch: 30 },
    { wch: 30 },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Re-inspection letter');

  // Write the workbook to a binary array
  const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

  // Create a Blob (this is what you append in FormData)
  const blob = new Blob([wbout], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  return blob;
};
